import React from 'react';
import EditableElement from './EditableField';
import TableWrapper from './TableWrapper';
import {
  MetadataElement,
  MetadataElementList,
  TableData
} from './SingleUploadModel';
import ReadOnlyField from './ReadOnlyField';

interface AssetMetaDataContainerProps {
  tableData: TableData[];
  assetMetadata: MetadataElementList;
  shouldShowElement?: any;
  assetId?: string;
}

const AssetMetaDataContainer: React.FC<AssetMetaDataContainerProps> = ({
  assetMetadata,
  tableData,
  shouldShowElement,
  assetId = '',
}) => {
  return (
    <div className="single-upload-content-header">
      <div className="single-upload-subtitle">{assetMetadata?.name}</div>

      <div className="single-upload-content-item">
        {assetMetadata?.metadata_element_list?.map(
          (element: MetadataElement) =>
            (shouldShowElement(element) || element.is_tabular === 'Y') && (
              <div
                key={element.field_id}
                id={element.field_id}
                className={`${
                  element.is_tabular === 'Y' ? 'asset-table' : 'asset-field'
                } asset-${assetMetadata.id
                  .toLowerCase()
                  .replaceAll('.', '-')}`}>
                {element.is_tabular !== 'Y' && (
                  <label
                    className={
                      element.is_required === 'Y'  ? 'required-field' : ''
                    }>
                    {element.prompt}
                  </label>
                )}

                {element.is_tabular === 'Y' ? (
                  <TableWrapper
                    element={element}
                    assetMetadata={assetMetadata}
                    tableData={tableData}
                  />
                ) :(assetId && element.is_displayable === 'Y' &&
                  element.is_editable === 'N' && element.is_cascade === 'N') ? (
                    <ReadOnlyField element={element} />
                  ) : (
                    <EditableElement element={element} assetId={assetId} />
                  )}
              </div>
            )
        )}
      </div>
    </div>
  );
};

export default AssetMetaDataContainer;
